import { Component, OnInit, Input, inject } from "@angular/core";
import { NgbPagination } from "@ng-bootstrap/ng-bootstrap/pagination";

import { ApiService } from "src/app/api.service";
import { DatetimePipe } from "src/app/pipes";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-mech-comm-failures",
	templateUrl: "./mech-comm-failures.component.html",
	styleUrls: ["./mech-comm-failures.component.scss"],
	imports: [NgbPagination, DatetimePipe]
})
export class MechCommFailuresComponent implements OnInit {
	api = inject(ApiService);


	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;

	public totalLogs = 0;
	public currentPage = 1;
	public itemsPerPage = 30;
	public pageLoading = false;
	public pageLogs: any[] = undefined;

	async ngOnInit() {
		this.refreshTable();
	}

	async updatePage() {
		try {
			this.pageLoading = true;
			const result = await this.api.GetCommFailures(this.asset.asset_id, this.itemsPerPage * (this.currentPage - 1), this.itemsPerPage);
			this.totalLogs = result.count;
			this.pageLogs = result.rows;
		} finally {
			this.pageLoading = false;
		}
	}

	refreshTable() {
		this.currentPage = 1;
		this.updatePage();
	}
}
